import { usePage } from '@inertiajs/react'
import type { PageProps } from '@/types/inertia.d'

export function useSidebarVM() {
  const { url } = usePage<PageProps>()

  const isActive = (href: string) => {
    if (href === '/admin') return url === '/admin'
    return url.startsWith(href)
  }

  return {
    isActive,
  }
}
